import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import * as pathsActions from '../paths/pathsSlice';
import * as selectedItemsActions from '../selectedItems/selectedItemsSlice';
import { ItemSelector } from '../selectedItems/SelectorComponents';

export function AllSources() {
  const dispatch = useDispatch();
  const selectedItems = useSelector((state) => state.selectedItems);

  const [searchParams, setSearchParams] = useSearchParams();

  // 2. Basic workflow setup setting receiptPoints as first select type
  useEffect(() => {
    // this is setting the first expected user action automatically.
    // TODO: this causes a re-render -  is there a smoother way to do it
    dispatch(
      selectedItemsActions.currentlySelectingChanged({
        selectionKey: 'deliveryPoints',
        itemType: 'point',
        multiSelect: true,
      }),
    );
  }, []);

  // update state with URL search params?  this is going to cause a loop.  Maybe it only makes sense on load, or maybe there's a history changed event we can listen to from router
  useEffect(() => {
    // TODO: I tried to move URL param stuff into each individual selector component which I think is the right way to do it but was running into issues
    // if we have to include it in here, it should at least be a function that gets called in the spirit of keeping things DRY

    // could also pass the results through URL unless it gets too large
    const deliveryPoints = searchParams.getAll('deliveryPoints');
    const receiptPoints = searchParams.getAll('receiptPoints');
    const constrainedEdges = searchParams.getAll('constrainedEdges');
    dispatch(
      selectedItemsActions.setState({
        deliveryPoints,
        receiptPoints,
        constrainedEdges,
      }),
    );
  }, []);

  // update search params in URL
  useEffect(() => {
    // this seems stupid, would rather update URL in redux thunk associated with selectors
    // const urlEncoded = JSON.stringify(selectedItems)
    // can also use the jsurl library if we need much shorter urls
    setSearchParams(selectedItems);
  }, [selectedItems]);

  // 5. cleanup when unmounting
  useEffect(
    () => () => {
      // what's the way to send one action that a bunch of slices respond to to clean up their state?
      dispatch(selectedItemsActions.resetState());
      dispatch(pathsActions.resetState());
    },
    [],
  );

  // 4. submit handler
  const handleSubmit = async () => {
    // TODO: this parameter stuff is all pretty similar between modes.  Should be centralized somehow
    const deliveryPoint = selectedItems.deliveryPoints[0];

    const { constrainedEdges } = selectedItems;
    const constrainedEdgeParams = `constrained_edges=${constrainedEdges.join(
      '&constrained_edges=',
    )}`;

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/path_study/?study_type=all_sources&delivery_points=${deliveryPoint}&${constrainedEdgeParams}`,
    );
    dispatch(pathsActions.pathDataReceived(res.data));
  };

  // 3. validation - very basic for now
  const submitValidated = selectedItems.deliveryPoints[0];

  // 1. selectors
  return (
    <>
      <ul className="list-group">
        <ItemSelector
          selectionKey="deliveryPoints"
          itemType="point"
          title="Delivery Point"
        />
        <ItemSelector
          selectionKey="constrainedEdges"
          itemType="edge"
          title="Constrained Edges"
          multiSelect
        />
      </ul>
      <button
        onClick={() => handleSubmit()}
        disabled={!submitValidated}
        className="btn btn-primary btn-block w-100"
      >
        Submit
      </button>
    </>
  );
}
